<!-- 必ずお読みください集 -->
<template>
  <div class="column">
    <!-- 必ずお読みください -->
    <h2 class="column-title">{{ $t("common.readit") }}</h2>

    <MbTermsUrl :url="url" />
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";

export default {
  name: "TheMbImportantLinkCollection",
  props: {
    url: {
      type: String,
      requried: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.column {
  margin-top: 15px;
  align-items: stretch;

  .column-title {
    margin: 18px 0 5px 0;
    font-size: 15px;
    font-weight: bold;
    color: #777777;
  }
}
</style>
